import { Table, TableBody, TableRow, TableCell, Checkbox, IconButton, Collapse, Box, Skeleton } from "@mui/material";
import TableHeader from "./TableHeader.jsx";

import { Fragment } from "react";



import TableCelldata from "../TableCellData.jsx";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ExpandableTableRow from "./ExpandableTableRow.jsx";




/** Presentational section; state and actions remain owned by its parent. */
export default function TableRows({ pageType, setting, canSelect, selected, rows, selectAll, headers, isAsc, setSort, setIsAsc, actions, lastElement, isSelected, handleClick, setAllRows, editApi, editInputApi, currentRow, setOpen, open, loading, rowLenght }) {
  return (
<Table
                stickyHeader
                sx={{
                  minWidth: 950,
                  transform: {
                    xs: pageType === 1 ? "rotateX(180deg)" : "",
                    md: "none",
                  },
                  /*        mt: 1, */
                  tableLayout: {
                    md: setting?.TableType !== "accordian" ? "fixed" : "auto",
                  },
                }}
                size="small"
              >
                <TableHeader canSelect={canSelect} selected={selected} rows={rows} selectAll={selectAll} headers={headers} isAsc={isAsc} setSort={setSort} setIsAsc={setIsAsc} actions={actions} setting={setting} />
                <TableBody>
                  {rows?.map((row, index) => {
                    return (
                      <Fragment key={index + "bdy"}>
                        {rows?.length === index + 1 && pageType === 1 ? (
                          <TableRow
                            ref={lastElement}
                            selected={isSelected(row)}
                            hover
                            sx={{
                              "& > *": {
                                borderBottom:
                                  setting?.TableType === "accordian"
                                    ? "unset !important"
                                    : "",
                              },
                            }}
                          >
                            {canSelect && (
                              <TableCell padding="checkbox">
                                <Checkbox
                                  onClick={() => handleClick(row)}
                                  checked={isSelected(row)}
                                />
                              </TableCell>
                            )}

                            {headers.map((item, i) => {
                              if (
                                row[item.name] !== undefined &&
                                item.showInList &&
                                !item.showInExtra
                              ) {
                                return (
                                  <Fragment key={i + "condi"}>
                                    <TableCell>
                                      <TableCelldata
                                        row={row}
                                        item={item}
                                        rows={rows}
                                        setAllRows={setAllRows}
                                        editApi={editApi}
                                        editInputApi={editInputApi}
                                      />
                                    </TableCell>
                                  </Fragment>
                                );
                              } else {
                                return (
                                  <Fragment key={i + "vdsvsd"}>
                                    <TableCell
                                      sx={{
                                        width: "0px !important",
                                        padding: "0px !important",
                                      }}
                                    ></TableCell>
                                  </Fragment>
                                );
                              }
                            })}
                            {actions &&
                              setting?.TableType !== "accordian" &&
                              actions?.map((action, index) => (
                                <TableCell
                                  onMouseDown={() => {
                                    currentRow(row);
                                  }}
                                  key={index + "actionBody"}
                                >
                                  {typeof action?.handler === "function" ? action.handler(row) : action?.handler}
                                </TableCell>
                              ))}
                            {setting?.TableType === "accordian" ? (
                              <TableCell>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={() =>
                                    setOpen({ [index]: !open[index] })
                                  }
                                  onMouseDown={() => currentRow(row)}
                                >
                                  {open[index] ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </TableCell>
                            ) : (
                              <></>
                            )}
                          </TableRow>
                        ) : (
                          <ExpandableTableRow setting={setting} isSelected={isSelected} row={row} canSelect={canSelect} handleClick={handleClick} headers={headers} setOpen={setOpen} index={index} open={open} currentRow={currentRow} rows={rows} setAllRows={setAllRows} editApi={editApi} editInputApi={editInputApi} actions={actions} />
                        )}
                        {setting?.TableType === "accordian" ? (
                          <TableRow>
                            <TableCell style={{ padding: 0 }} colSpan={40}>
                              <Collapse
                                in={open[index]}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Box
                                  sx={{
                                    background: (theme) =>
                                      theme.palette.mode === "light"
                                        ? "rgb(239 246 255)"
                                        : "rgb(32 44 85)",
                                  }}
                                  className="flex flex-wrap gap-8 mb-4 p-4 border-t border-dashed"
                                >
                                  <div className="flex items-center gap-4">
                                    {headers.map((item, i) => {
                                      if (
                                        row[item.name] !== undefined &&
                                        item.showInList &&
                                        item.showInExtra
                                      ) {
                                        return (
                                          <Fragment key={i + "dsvsdvds11"}>
                                            <span className="text-[#8c8c8c]">
                                              {item.title} :{" "}
                                            </span>
                                            <span className="font-bold">
                                              {" "}
                                              <TableCelldata
                                                row={row}
                                                item={item}
                                                rows={rows}
                                                setAllRows={setAllRows}
                                                editApi={editApi}
                                                editInputApi={editInputApi}
                                              />
                                            </span>
                                          </Fragment>
                                        );
                                      }
                                    })}
                                  </div>
                                  {actions &&
                                    actions?.map((action, index) => (
                                      <Fragment key={`frjgxxxx` + index}>
                                        {typeof action?.handler === "function" ? action.handler(row) : action?.handler}
                                      </Fragment>
                                    ))}
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        ) : (
                          <></>
                        )}
                      </Fragment>
                    );
                  })}
                  {loading && !rows?.length && (
                    <>
                      {Array.from(Array(3).keys()).map((item, i) => (
                        <TableRow key={i + "TableRowLoading"}>
                          <>
                            {rowLenght.map((item, index) => (
                              <TableCell
                                sx={{
                                  padding: item.display
                                    ? "4px"
                                    : "0px !important",
                                }}
                                /*    colSpan={item.display ? item.colSpan : 1} */
                                key={index + "TableCellLoadingChild"}
                              >
                                {item.display ? (
                                  <Skeleton height={30} />
                                ) : (
                                  <></>
                                )}
                              </TableCell>
                            ))}
                          </>
                        </TableRow>
                      ))}
                    </>
                  )}
                </TableBody>
              </Table>
  );
}
